"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  TimeClockFile1: ['time-clock-file-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.707,5.708,16.293.294A1,1,0,0,0,15.586,0H4A2,2,0,0,0,2,2V22a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V6.415A1,1,0,0,0,21.707,5.708ZM20,21.5a.5.5,0,0,1-.5.5H4.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,4.5,2H14.965a.5.5,0,0,1,.353.146l4.536,4.535A.5.5,0,0,1,20,7.036Z', 'M12,6.5a6,6,0,1,0,6,6A6.006,6.006,0,0,0,12,6.5Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,12,16.5Z', 'M13.251,11.5A.251.251,0,0,1,13,11.25v-.959a1,1,0,0,0-2,0V12.5a1,1,0,0,0,1,1h2.21a1,1,0,0,0,0-2Z']],
  TimeClockFileAdd: ['time-clock-file-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM9,18.251H7.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H4a.75.75,0,0,1,0-1.5H5.5a.25.25,0,0,0,.25-.25V15a.75.75,0,1,1,1.5,0v1.5a.25.25,0,0,0,.25.25H9a.75.75,0,0,1,0,1.5Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileDownload: ['time-clock-file-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.391,7.312-2,2.5a.5.5,0,0,1-.782,0l-2-2.5A.5.5,0,0,1,4.5,17.5h.748a.252.252,0,0,0,.252-.252V14.5a1,1,0,1,1,2,0v2.75a.25.25,0,0,0,.25.25H8.5a.5.5,0,0,1,.391.812Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileHome: ['time-clock-file-home', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.868a.249.249,0,0,0,.33.232,2.479,2.479,0,0,1,1.34,0A.25.25,0,0,0,8,9.868V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H16.176a.253.253,0,0,0-.244.229,1.977,1.977,0,0,1-.958,1.316.25.25,0,0,0,.146.455H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M7.324,12.119a.5.5,0,0,0-.647,0l-6.5,5.5A.5.5,0,0,0,.5,18.5H1.75a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.5.5H5a.5.5,0,0,0,.5-.5v-2.25a1.5,1.5,0,0,1,3,0V23.5A.5.5,0,0,0,9,24h2.5a.5.5,0,0,0,.5-.5v-4.75a.25.25,0,0,1,.25-.25H13.5a.5.5,0,0,0,.324-.882Z', 'M20.25,8.5a4.75,4.75,0,1,0-4.75,4.75A4.756,4.756,0,0,0,20.25,8.5Zm-8,0a3.25,3.25,0,1,1,3.25,3.25A3.254,3.254,0,0,1,12.25,8.5Z', 'M17.268,9.251a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5a.75.75,0,0,0,.75.75Z']],
  TimeClockFileSearch: ['time-clock-file-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.363,3.069,20.948.655A1.75,1.75,0,0,0,19.711.142H8.125a1.75,1.75,0,0,0-1.75,1.75V9.218a.247.247,0,0,0,.215.243A6.8,6.8,0,0,1,7.6,9.683a.221.221,0,0,0,.273-.225V1.892a.251.251,0,0,1,.25-.25H19.711l.177.074L22.3,4.13a.249.249,0,0,1,.073.177V18.392a.251.251,0,0,1-.25.25H12.419a.244.244,0,0,0-.229.163,7.191,7.191,0,0,1-.307.721.312.312,0,0,0,.041.337l.21.21a.173.173,0,0,0,.14.069h9.851a1.749,1.749,0,0,0,1.75-1.75V4.307A1.753,1.753,0,0,0,23.363,3.069Z', 'M10.293,19.647a.243.243,0,0,1-.031-.3A5.512,5.512,0,1,0,8.575,21.03a.243.243,0,0,1,.3.03l2.505,2.506A1,1,0,1,0,12.8,22.152Zm-4.668.245a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,5.625,19.892Z', 'M15.625,13.142a4.75,4.75,0,1,0-4.75-4.75A4.755,4.755,0,0,0,15.625,13.142Zm0-8a3.25,3.25,0,1,1-3.25,3.25A3.254,3.254,0,0,1,15.625,5.142Z', 'M15.625,9.142h1.768a.75.75,0,1,0,0-1.5h-.767a.251.251,0,0,1-.251-.251V6.625a.75.75,0,0,0-1.5,0V8.392A.75.75,0,0,0,15.625,9.142Z']],
  TimeClockFileSetting: ['time-clock-file-setting', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.415,3,21,.587A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V8.357a.245.245,0,0,0,.214.247,7.875,7.875,0,0,1,1.45.318A.247.247,0,0,0,8,8.69V2.5A.5.5,0,0,1,8.5,2H19.38a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.126a.249.249,0,0,0-.236.32,3.229,3.229,0,0,1,.047,1.377.249.249,0,0,0,.24.3H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.415,3Z', 'M17.136,12.961a4.712,4.712,0,0,0,2.977-3.3,4.753,4.753,0,1,0-9.25-2.188,4.684,4.684,0,0,0,.739,3.713.519.519,0,0,0,.225.175A6.4,6.4,0,0,1,13.5,12.745a.516.516,0,0,0,.188.136A4.692,4.692,0,0,0,17.136,12.961ZM12.251,8.5a3.25,3.25,0,1,1,3.25,3.25A3.254,3.254,0,0,1,12.251,8.5Z', 'M4.751 17.032 A1.500 1.500 0 1 0 7.751 17.032 A1.500 1.500 0 1 0 4.751 17.032 Z', 'M12.019,15.655a1.782,1.782,0,0,0-1.7-2.953l-1.41.327a.452.452,0,0,1-.534-.311L7.95,11.326a1.774,1.774,0,0,0-3.4,0l-.424,1.391a.456.456,0,0,1-.533.312L2.184,12.7a1.782,1.782,0,0,0-1.7,2.953l.988,1.064a.464.464,0,0,1,0,.626L.483,18.41a1.783,1.783,0,0,0,1.7,2.953l1.41-.327a.452.452,0,0,1,.534.311l.424,1.392a1.775,1.775,0,0,0,3.4,0l.424-1.392a.453.453,0,0,1,.533-.311l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.988-1.065a.464.464,0,0,1,0-.626ZM6.251,20.032a3,3,0,1,1,3-3A3,3,0,0,1,6.251,20.032Z', 'M17.269,9.251a.75.75,0,1,0,0-1.5H16.5a.252.252,0,0,1-.251-.252V6.733a.75.75,0,1,0-1.5,0V8.5a.75.75,0,0,0,.75.75Z']],
  TimeClockFileShare: ['time-clock-file-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V12.016a.25.25,0,0,0,.469.121A6.2,6.2,0,0,1,7.9,10.223a.232.232,0,0,0,.1-.191V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H13.981a.246.246,0,0,0-.211.379,4.245,4.245,0,0,1,.616,1.425.246.246,0,0,0,.238.2H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M18.75,8.5a3.254,3.254,0,0,1-3.25,3.25,3.161,3.161,0,0,1-1.419-.338c-.116-.071-.231.065-.2.17a4.2,4.2,0,0,1,.524,1.366.467.467,0,0,0,.22.212,4.488,4.488,0,0,0,.873.09A4.75,4.75,0,1,0,10.75,8.5a4.587,4.587,0,0,0,.107.958.258.258,0,0,0,.123.121,4.181,4.181,0,0,1,1.506.58c.092.038.191-.071.123-.2A3.159,3.159,0,0,1,12.25,8.5a3.25,3.25,0,0,1,6.5,0Z', 'M8.442,16a.245.245,0,0,1,.266.012,2.74,2.74,0,0,0,4.167-1.425A2.758,2.758,0,0,0,10.25,11a2.807,2.807,0,0,0-2.713,3.058.243.243,0,0,1-.115.222L4.558,16a.245.245,0,0,1-.266-.012,2.707,2.707,0,0,0-2.406-.349A2.706,2.706,0,0,0,.124,17.414,2.759,2.759,0,0,0,2.75,21a2.729,2.729,0,0,0,1.887-.761.246.246,0,0,1,.259-.054s1.924.782,2.464,1a.237.237,0,0,1,.144.214,2.753,2.753,0,1,0,5.361-1.025,2.681,2.681,0,0,0-1.736-1.74,2.74,2.74,0,0,0-2.767.623.242.242,0,0,1-.258.053L5.553,18.3a.114.114,0,0,1-.06-.084l-.03-.353a.118.118,0,0,1,.056-.1Z', 'M15.5,5.983a.75.75,0,0,0-.75.75V8.5a.75.75,0,0,0,.75.75h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733A.75.75,0,0,0,15.5,5.983Z']],
  TimeClockFileRemove: ['time-clock-file-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm1.237,6.677,1.414,1.414a.75.75,0,0,1-1.06,1.06L6.677,18.738a.25.25,0,0,0-.354,0L4.909,20.153a.75.75,0,0,1-1.061-1.061l1.414-1.414a.25.25,0,0,0,0-.354L3.849,15.91a.75.75,0,1,1,1.06-1.061l1.414,1.415a.252.252,0,0,0,.354,0l1.414-1.415A.75.75,0,0,1,9.152,15.91L7.738,17.324A.251.251,0,0,0,7.737,17.678Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileSubtract: ['time-clock-file-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM9,18.251H4a.75.75,0,0,1,0-1.5H9a.75.75,0,0,1,0,1.5Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileWarning: ['time-clock-file-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.362,3.053,20.947.638A1.749,1.749,0,0,0,19.71.126H8.124a1.75,1.75,0,0,0-1.75,1.75v7.8a.245.245,0,0,0,.222.248,7.37,7.37,0,0,1,.963.152.249.249,0,0,0,.315-.24V1.876a.251.251,0,0,1,.25-.25H19.71l.177.073L22.3,4.113a.249.249,0,0,1,.073.177V18.376a.251.251,0,0,1-.25.25h-8.9c-.134,0-.151.133-.1.232l.6,1.134a.251.251,0,0,0,.222.134h8.187a1.75,1.75,0,0,0,1.75-1.75V4.29A1.749,1.749,0,0,0,23.362,3.053Z', 'M7.905,12.147a1.449,1.449,0,0,0-2.561,0L.289,21.781a1.426,1.426,0,0,0,.047,1.408,1.454,1.454,0,0,0,1.233.687H11.68a1.456,1.456,0,0,0,1.233-.686,1.428,1.428,0,0,0,.047-1.409ZM5.874,15.876a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0Zm.75,6.25a1,1,0,1,1,1-1A1,1,0,0,1,6.624,22.126Z', 'M20.374,8.376a4.75,4.75,0,1,0-4.75,4.75A4.755,4.755,0,0,0,20.374,8.376Zm-8,0a3.25,3.25,0,1,1,3.25,3.25A3.254,3.254,0,0,1,12.374,8.376Z', 'M17.392,9.126a.75.75,0,1,0,0-1.5h-.766a.252.252,0,0,1-.252-.252V6.608a.75.75,0,0,0-1.5,0V8.376a.75.75,0,0,0,.75.75Z']],
  TimeClockFile: ['time-clock-file', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.585A2,2,0,0,0,19.586,0H8.125a2,2,0,0,0-2,2V9.151a.247.247,0,0,0,.242.249c.366.007,1.038.034,1.485.083a.247.247,0,0,0,.273-.249V2.5a.5.5,0,0,1,.5-.5H19.379a.5.5,0,0,1,.353.146l2.122,2.122A.5.5,0,0,1,22,4.621V17.875a.5.5,0,0,1-.5.5H14.767a.244.244,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.414A2,2,0,0,0,23.414,3Z', 'M6.75,10.5a6.75,6.75,0,1,0,6.75,6.75A6.758,6.758,0,0,0,6.75,10.5Zm0,11.5a4.75,4.75,0,1,1,4.75-4.75A4.756,4.756,0,0,1,6.75,22Z', 'M8.75,16.25H8A.25.25,0,0,1,7.75,16V14.75a1,1,0,0,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z']],
  TimeClockFileCash: ['time-clock-file-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11ZM7.538,21.178c-.094.024-.288.109-.288.294v.279a.75.75,0,0,1-1.5,0V21.5a.248.248,0,0,0-.248-.247H5a.75.75,0,0,1,0-1.5H7.033a.592.592,0,0,0,.22-1.141L5.19,17.785a2.085,2.085,0,0,1,.343-3.978.333.333,0,0,0,.217-.328v-.228a.75.75,0,1,1,1.5,0v.25a.25.25,0,0,0,.25.25H8a.75.75,0,0,1,0,1.5H5.967a.592.592,0,0,0-.22,1.141l2.063.825a2.084,2.084,0,0,1-.272,3.961Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileUpload: ['time-clock-file-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm2.45,6.217a.5.5,0,0,1-.45.283H7.752a.252.252,0,0,0-.252.252V20.5a1,1,0,0,1-2,0v-2.75a.25.25,0,0,0-.25-.25H4.5a.5.5,0,0,1-.391-.813l2-2.5a.5.5,0,0,1,.782,0l2,2.5A.5.5,0,0,1,8.95,17.218Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileFavoriteHeart: ['time-clock-file-favorite-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2v9.573a.258.258,0,0,0,.076.189c.467.42,1.247-.214,1.768-.455A.254.254,0,0,0,8,11.078V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.354.146l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H13.97a.254.254,0,0,0-.208.111c-.237.334-.844,1.027-1.243,1.474a.249.249,0,0,0,.189.414H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M12.628,14.45A3.505,3.505,0,0,0,9.584,12.5,3.657,3.657,0,0,0,6.89,13.627l-.212.212a.252.252,0,0,1-.354,0l-.212-.212A3.66,3.66,0,0,0,3.418,12.5a3.527,3.527,0,0,0-2.391,6.012L6.14,23.847a.5.5,0,0,0,.722,0l5.106-5.327A3.522,3.522,0,0,0,12.628,14.45Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.751,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.251,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileRefresh: ['time-clock-file-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.362,3.053,20.948.638A1.749,1.749,0,0,0,19.711.126H8.125a1.749,1.749,0,0,0-1.75,1.75V9.143a.246.246,0,0,0,.238.25c.26.007.675.023.992.051a.247.247,0,0,0,.27-.248V1.876a.251.251,0,0,1,.25-.25H19.711l.177.073L22.3,4.113a.249.249,0,0,1,.073.177V18.376a.251.251,0,0,1-.25.25h-7.4a.241.241,0,0,0-.237.2,8.044,8.044,0,0,1-.355,1.3h8a1.75,1.75,0,0,0,1.75-1.75V4.29A1.746,1.746,0,0,0,23.362,3.053Z', 'M18.875,8.376a3.254,3.254,0,0,1-3.25,3.25,3.14,3.14,0,0,1-.964-.156c-.06-.019-.157.013-.148.073.051.314.089,1,.1,1.311a.25.25,0,0,0,.175.194,4.568,4.568,0,0,0,.833.078,4.75,4.75,0,1,0-4.75-4.75,4.65,4.65,0,0,0,.465,2,.232.232,0,0,0,.24.053,1.965,1.965,0,0,1,1.043-.308.173.173,0,0,0,.135-.226,3.208,3.208,0,0,1-.383-1.519,3.25,3.25,0,0,1,6.5,0Z', 'M11.9,18.476a1,1,0,0,0-1.257.584,4.025,4.025,0,0,1-1.276,1.929,4.163,4.163,0,0,1-5.657-.472.254.254,0,0,1,.014-.348l1.717-1.717a.5.5,0,0,0-.354-.854H.625a.5.5,0,0,0-.5.5v4.458a.5.5,0,0,0,.854.353l.974-.975a.244.244,0,0,1,.353.009,6.085,6.085,0,0,0,10.211-2.2A1,1,0,0,0,11.9,18.476Z', 'M12.816,11.648a.5.5,0,0,0-.545.109l-1.03,1.03a.245.245,0,0,1-.352-.007,6.1,6.1,0,0,0-10.2,2.225,1,1,0,0,0,1.88.684,4.018,4.018,0,0,1,1.272-1.916,4.155,4.155,0,0,1,5.637.435.255.255,0,0,1-.012.35L7.814,16.214a.5.5,0,0,0,.354.853h4.457a.5.5,0,0,0,.5-.5V12.11A.5.5,0,0,0,12.816,11.648Z', 'M15.625,5.858a.75.75,0,0,0-.75.75V8.376a.75.75,0,0,0,.75.75h1.768a.75.75,0,1,0,0-1.5h-.767a.252.252,0,0,1-.251-.252V6.608A.75.75,0,0,0,15.625,5.858Z']],
  TimeClockFileFavorite: ['time-clock-file-favorite', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.413,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V8.792a.252.252,0,0,0,.232.25,8.455,8.455,0,0,1,1.452.212A.248.248,0,0,0,8,9.014V2.5A.5.5,0,0,1,8.5,2H19.378a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.162a.232.232,0,0,0-.163.06c-.21.191-.87.785-1.174,1.059-.095.086-.14.175-.106.252s.173.4.212.489a.252.252,0,0,0,.215.139H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.413,3Z', 'M12.608,17.139a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,11.739,15h-2.5a.249.249,0,0,1-.229-.15L7.665,11.732,7.652,11.7a1.295,1.295,0,0,0-2.3,0l-.012.028L3.991,14.849a.251.251,0,0,1-.23.15h-2.5a1.232,1.232,0,0,0-1.169.762,1.262,1.262,0,0,0,.3,1.378L2.6,19.11a.251.251,0,0,1,.063.287L1.443,22.212a1.253,1.253,0,0,0,.316,1.45,1.273,1.273,0,0,0,1.505.166l3.113-1.752a.251.251,0,0,1,.245,0l3.113,1.752a1.275,1.275,0,0,0,1.506-.166,1.254,1.254,0,0,0,.315-1.45L10.333,19.4a.249.249,0,0,1,.063-.287Z', 'M15.5,13.251a4.75,4.75,0,1,0-4.75-4.75A4.756,4.756,0,0,0,15.5,13.251Zm0-8a3.25,3.25,0,1,1-3.25,3.25A3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5a.252.252,0,0,1-.252-.252V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileBlock: ['time-clock-file-block', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.276a.244.244,0,0,0,.255.244,8.165,8.165,0,0,1,1.46.086A.245.245,0,0,0,8,9.365V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.635a.242.242,0,0,0-.24.209,8,8,0,0,1-.363,1.459.244.244,0,0,0,.229.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M6.5,11A6.5,6.5,0,1,0,13,17.5,6.5,6.5,0,0,0,6.5,11ZM2.533,19.6a4.45,4.45,0,0,1-.367-3.32,4.5,4.5,0,0,1,3.112-3.116,4.444,4.444,0,0,1,3.325.367.252.252,0,0,1,.052.4L2.931,19.655A.252.252,0,0,1,2.533,19.6Zm8.3-.887a4.494,4.494,0,0,1-3.112,3.116A4.438,4.438,0,0,1,4.4,21.467a.252.252,0,0,1-.052-.4l5.724-5.722a.252.252,0,0,1,.4.051A4.448,4.448,0,0,1,10.834,18.717Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileCheck: ['time-clock-file-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm3.273,5.205-2.9,3.874a1.49,1.49,0,0,1-1.1.6c-.035,0-.071,0-.106,0a1.5,1.5,0,0,1-1.061-.441l-1.5-1.5a.75.75,0,1,1,1.061-1.06l1.3,1.3a.25.25,0,0,0,.377-.027l2.732-3.643a.75.75,0,1,1,1.2.9Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileQuestion: ['time-clock-file-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,11A6.5,6.5,0,1,0,13,17.5,6.508,6.508,0,0,0,6.5,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,6.5,22.5Zm.939-4.173a.269.269,0,0,0-.189.273v.15a.75.75,0,0,1-1.5,0V18.2a1.256,1.256,0,0,1,.988-1.222,1.125,1.125,0,1,0-1.363-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,3.564,2.452Z', 'M23.414,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2V9.276a.247.247,0,0,0,.242.25c.366.007,1.038.034,1.485.083A.247.247,0,0,0,8,9.36V2.251A.25.25,0,0,1,8.25,2H19.482a.249.249,0,0,1,.177.073l2.268,2.268A.248.248,0,0,1,22,4.518V18.251a.25.25,0,0,1-.25.25H14.642a.243.243,0,0,0-.241.21,7.935,7.935,0,0,1-.364,1.458.244.244,0,0,0,.228.331H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M15.5,13.251A4.75,4.75,0,1,0,10.75,8.5,4.756,4.756,0,0,0,15.5,13.251Zm0-8A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileTimer: ['time-clock-file-timer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.487,2.928,21.073.514A1.76,1.76,0,0,0,19.836,0H8.25A1.752,1.752,0,0,0,6.5,1.751V9.264c.084,0,.166-.013.25-.013A7.925,7.925,0,0,1,8,9.359V1.751a.25.25,0,0,1,.25-.25H19.836a.257.257,0,0,1,.177.073l2.414,2.414a.251.251,0,0,1,.073.177V18.251a.25.25,0,0,1-.25.25H14.642a8,8,0,0,1-.389,1.5h8A1.752,1.752,0,0,0,24,18.251V4.165A1.736,1.736,0,0,0,23.487,2.928Z', 'M6.75,10.5a6.75,6.75,0,1,0,6.75,6.75A6.758,6.758,0,0,0,6.75,10.5Zm0,11.5a4.75,4.75,0,1,1,4.75-4.75A4.756,4.756,0,0,1,6.75,22Z', 'M8.75,16.251H8A.25.25,0,0,1,7.75,16v-1.25a1,1,0,1,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z', 'M15.75,13A4.75,4.75,0,1,0,11,8.251,4.756,4.756,0,0,0,15.75,13Zm0-8a3.25,3.25,0,1,1-3.25,3.25A3.254,3.254,0,0,1,15.75,5Z', 'M15.75,9h1.768a.75.75,0,1,0,0-1.5h-.767a.252.252,0,0,1-.251-.252V6.483a.75.75,0,0,0-1.5,0V8.251A.75.75,0,0,0,15.75,9Z']],
  TimeClockFileEdit: ['time-clock-file-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.413,3,21,.587A2,2,0,0,0,19.585,0H8A2,2,0,0,0,6,2v9.582a.249.249,0,0,0,.421.182c.481-.467,1.235-1.193,1.5-1.426A.241.241,0,0,0,8,10.156V2.5A.5.5,0,0,1,8.5,2H19.378a.5.5,0,0,1,.354.147l2.121,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H11.431a.25.25,0,0,0-.177.074l-1.5,1.5a.249.249,0,0,0,.177.426H22a2,2,0,0,0,2-2V4.416A2,2,0,0,0,23.413,3Z', 'M13.99,11.675a4.09,4.09,0,0,1,.437,1.3.357.357,0,0,0,.149.18,4.6,4.6,0,0,0,.923.1,4.75,4.75,0,1,0-4.75-4.75,4.616,4.616,0,0,0,.091.887.439.439,0,0,0,.226.189,4.059,4.059,0,0,1,1.284.444c.154.085.245-.051.165-.233a3.25,3.25,0,1,1,1.649,1.676C14,11.389,13.9,11.512,13.99,11.675Z', 'M1.061,20.132a.25.25,0,0,0-.422.128L.011,23.4A.5.5,0,0,0,.5,24a.55.55,0,0,0,.1-.009l3.143-.629a.25.25,0,0,0,.128-.422Z', 'M12.035,11.592a2.71,2.71,0,0,0-3.606.273l-6.58,6.58a.252.252,0,0,0,0,.354L5.2,22.152a.249.249,0,0,0,.353,0l6.679-6.679A2.622,2.622,0,0,0,12.035,11.592Z', 'M15.5,5.984a.75.75,0,0,0-.75.75V8.5a.75.75,0,0,0,.75.75h1.768a.75.75,0,1,0,0-1.5H16.5a.251.251,0,0,1-.252-.251V6.734A.75.75,0,0,0,15.5,5.984Z']],
  TimeClockFileLock: ['time-clock-file-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.363,3.053,20.948.638A1.749,1.749,0,0,0,19.711.126H8.125a1.749,1.749,0,0,0-1.75,1.75V9.649a.242.242,0,0,0,.169.228,4.466,4.466,0,0,1,1.078.53c.086.058.253.059.253-.111V1.876a.251.251,0,0,1,.25-.25H19.711l.177.073L22.3,4.113a.249.249,0,0,1,.073.177V18.376a.251.251,0,0,1-.25.25H11.875a.25.25,0,0,0-.25.25v1a.25.25,0,0,0,.25.25h10.25a1.75,1.75,0,0,0,1.75-1.75V4.29A1.749,1.749,0,0,0,23.363,3.053Z', 'M8.736,15.388a.123.123,0,0,1-.111-.12V14.126a3.5,3.5,0,1,0-7,0V15.26a.114.114,0,0,1-.113.128A1.5,1.5,0,0,0,.125,16.876v5.5a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5v-5.5A1.5,1.5,0,0,0,8.736,15.388ZM5.125,21.126a1,1,0,1,1,1-1A1,1,0,0,1,5.125,21.126Zm1.5-5.866a.121.121,0,0,1-.106.116l-2.782,0a.122.122,0,0,1-.112-.116V14.126a1.5,1.5,0,1,1,3,0Z', 'M15.625,13.126a4.75,4.75,0,1,0-4.75-4.75A4.756,4.756,0,0,0,15.625,13.126Zm0-8a3.25,3.25,0,1,1-3.25,3.25A3.254,3.254,0,0,1,15.625,5.126Z', 'M15.625,9.126h1.768a.75.75,0,1,0,0-1.5h-.767a.252.252,0,0,1-.251-.252V6.608a.75.75,0,0,0-1.5,0V8.376A.75.75,0,0,0,15.625,9.126Z']],
  TimeClockFileShield: ['time-clock-file-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,3,21,.586A2,2,0,0,0,19.586,0H8A2,2,0,0,0,6,2V9.267a.248.248,0,0,0,.244.25c.368,0,1.045.021,1.5.047A.246.246,0,0,0,8,9.315V2.5A.5.5,0,0,1,8.5,2H19.379a.5.5,0,0,1,.353.146l2.122,2.121A.5.5,0,0,1,22,4.622V18a.5.5,0,0,1-.5.5H14.49a.242.242,0,0,0-.235.183,8.16,8.16,0,0,1-.53,1.46.245.245,0,0,0,.218.356H22a2,2,0,0,0,2-2V4.415A2,2,0,0,0,23.414,3Z', 'M11.308,10.2a11.232,11.232,0,0,1,1.365.465,3.035,3.035,0,0,1,1.76,2.184.638.638,0,0,0,.262.326,4.635,4.635,0,0,0,.8.074A4.75,4.75,0,1,0,10.75,8.5a4.55,4.55,0,0,0,.2,1.322A.98.98,0,0,0,11.308,10.2ZM15.5,5.251A3.25,3.25,0,1,1,12.25,8.5,3.254,3.254,0,0,1,15.5,5.251Z', 'M12.072,12.041A16.381,16.381,0,0,0,6.479,11a15.983,15.983,0,0,0-5.551,1.04A1.545,1.545,0,0,0,0,13.457v3.392a7.716,7.716,0,0,0,5.19,6.806A9,9,0,0,0,6.479,24a9.023,9.023,0,0,0,1.288-.346C10.848,22.481,13,19.682,13,16.849V13.457A1.545,1.545,0,0,0,12.072,12.041ZM9.5,17.251h-2a.25.25,0,0,0-.25.25v2a.75.75,0,0,1-1.5,0v-2a.25.25,0,0,0-.25-.25h-2a.75.75,0,1,1,0-1.5h2a.25.25,0,0,0,.25-.25v-2a.75.75,0,1,1,1.5,0v2a.25.25,0,0,0,.25.25h2a.75.75,0,1,1,0,1.5Z', 'M15.5,9.251h1.768a.75.75,0,1,0,0-1.5H16.5A.252.252,0,0,1,16.25,7.5V6.733a.75.75,0,0,0-1.5,0V8.5A.75.75,0,0,0,15.5,9.251Z']],
  TimeClockFileSync: ['time-clock-file-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.487,2.928,21.073.513A1.749,1.749,0,0,0,19.836,0H8.25A1.749,1.749,0,0,0,6.5,1.751V9.786a.247.247,0,0,0,.241.246,7.7,7.7,0,0,1,.968.1A.248.248,0,0,0,8,9.892V1.751a.251.251,0,0,1,.25-.25H19.836l.177.073,2.414,2.414a.249.249,0,0,1,.073.177V18.251a.251.251,0,0,1-.25.25H14.357a.247.247,0,0,0-.242.208,7.167,7.167,0,0,1-.3,1.178c-.014.038.022.114.175.114H22.25A1.75,1.75,0,0,0,24,18.251V4.165A1.746,1.746,0,0,0,23.487,2.928Z', 'M19,8.251a3.254,3.254,0,0,1-3.25,3.25,3.164,3.164,0,0,1-.87-.124.212.212,0,0,0-.254.221c.042.327.074.8.09,1.067a.314.314,0,0,0,.194.256,4.654,4.654,0,0,0,.84.08A4.75,4.75,0,1,0,11,8.251a4.635,4.635,0,0,0,.456,1.981.277.277,0,0,0,.276.08,1.959,1.959,0,0,1,.984-.274.2.2,0,0,0,.164-.263A3.25,3.25,0,1,1,19,8.251Z', 'M12.92,11.56a.5.5,0,0,0-.545.109l-1.3,1.3a.245.245,0,0,1-.343,0,6.312,6.312,0,0,0-4.078-1.716A6.465,6.465,0,0,0,0,17.547,6.375,6.375,0,0,0,11.357,21.6,1,1,0,1,0,9.8,20.354,4.374,4.374,0,1,1,9.3,14.372a.258.258,0,0,1,0,.368L7.918,16.126a.5.5,0,0,0,.353.853h4.458a.5.5,0,0,0,.5-.5V12.022A.5.5,0,0,0,12.92,11.56Z', 'M15.75,5.733a.75.75,0,0,0-.75.75V8.251a.75.75,0,0,0,.75.75h1.768a.75.75,0,1,0,0-1.5h-.767a.252.252,0,0,1-.251-.252V6.483A.75.75,0,0,0,15.75,5.733Z']]
};
exports["default"] = _default;